import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	allWallets: [],
};

export const portfolioSlice = createSlice({
	name: 'portfolio',
	initialState,
	reducers: {
		resetState: () => initialState,
		setAllWallets: (state, action) => {
			const { payload: wallets = [] } = action;
			state.allWallets = wallets;
		},
	},
});
